import ActionUtility from "utilities/ActionUtility";

export default class CommonAction {
  static SET_CURRENT_VIEW = "CommonAction.SET_CURRENT_VIEW";
  static SET_CURRENT_LANGUAGE = "CommonAction.SET_CURRENT_LANGUAGE";
  static SET_PAGE_OPTIONS = "CommonAction.SET_PAGE_OPTIONS";
  static SET_SELECTED_DOCUMENT = "CommonAction.SET_SELECTED_DOCUMENT";
  static SET_CURRENT_POSITION = "CommonAction.SET_CURRENT_POSITION";

  static setCurrentView(currentView) {
    return async (dispatch) => {
      dispatch(
        ActionUtility.createAction(CommonAction.SET_CURRENT_VIEW, currentView)
      );
    };
  }
  static setCurrentLanguage(language) {
    return async (dispatch) => {
      dispatch(
        ActionUtility.createAction(CommonAction.SET_CURRENT_LANGUAGE, language)
      );
    };
  }
  
  static setPageOptions(options) {
    return async (dispatch) => {
      dispatch(ActionUtility.createAction(CommonAction.SET_PAGE_OPTIONS, options));
    };
  }
  
  static setSelectedDocument(documentId) {
    return async (dispatch) => {
      dispatch(
        ActionUtility.createAction(CommonAction.SET_SELECTED_DOCUMENT, documentId)
      );
    };
  }
  
  static setCurrentPosition(position) {
    return async (dispatch) => {
      dispatch(
        ActionUtility.createAction(CommonAction.SET_CURRENT_POSITION, position)
      );
    };
  }
}
